



















import { Vue, Component } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { Toast } from 'vant';
import { save } from '../api';
const phoneReg = /^1[345789][0-9]{9}$/;
@Component
export default class ViewHolder extends Vue {
  input: any = [
    {
      text: '学校名称',
      value: 'school_name',
      placeholder: '请输入',
      tip: '请输入学校名称',
      reg: '',
    },
    {
      text: '姓名',
      value: 'name',
      placeholder: '请输入',
      tip: '请输入姓名',
      reg: '',
    },
    {
      text: '职务',
      value: 'job',
      placeholder: '请输入',
      tip: '请输入职务',
      reg: '',
    },
    {
      text: '电话号码',
      value: 'phone',
      placeholder: '请输入',
      tip: '电话号码格式错误',
      reg: phoneReg,
    },
    {
      text: '联系地址',
      value: 'address',
      placeholder: '请输入',
      tip: '请输入联系地址',
      reg: '',
    },
    {
      text: '联系邮箱',
      value: 'email',
      placeholder: '请输入',
      tip: '请输入联系邮箱',
      reg: '',
    },
  ];
  form: any = {
    school_name: '',
    name: '',
    job: '',
    phone: '',
    address: '',
    email: '',
  };
  get inApp() {
    return !!window.udid;
  }
  activated() {
    if (!this.inApp) {
      this.$openAppTip();
      return false;
    }
    const userLogin = window.gettoken() && window.gettoken() !== 'null';
    if (window.udid && !userLogin) {
      window.handleMessage('{"action":"mUserLogin","data":""}');
      return false;
    }
  }

  async submit() {
    for (const item of this.input) {
      const phoneReg = /^1[345789][0-9]{9}$/;
      if (
        !this.form[item.value] ||
        (item.reg && !item.reg.test(this.form[item.value]))
      ) {
        Toast(item.tip);
        return false;
      }
    }
    this.form.udid = window.udid;
    this.form.appkey = window.appkey;
    this.form.token = window.gettoken();
    const res: any = await save(this.form);
    if (res.code === 200) {
      Toast.success(res.msg);
      setTimeout(() => {
        this.$router.go(0);
      }, 2000);
    } else {
      Toast.fail(res.msg);
    }
  }
}
